import { 
    createRouter, 
    // createWebHistory,
    createWebHashHistory 
} from 'vue-router'

const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: () => import('../views/DashboardView.vue')
    },
    {
        path: '/projects',
        name: 'projects',
        component: () => import('../views/ProjectsView.vue')
    },
    {
        path: '/datastorage',
        name: 'datafolders',
        component: () => import('../views/DataFoldersView.vue'),
        meta: { permission: 'datastorage' }
    },
    {
        path: '/datastorage/:id',
        name: 'datastorage',
        component: () => import('../views/DataStorageView.vue'),
        meta: { permission: 'datastorage' }
    },
    {
        path: '/datastorage/:category/:id',
        name: 'datapage',
        component: () => import('../views/DataView.vue'),
        meta: { permission: 'datastorage' }
    },
    {
        path: '/datastorage/new',
        name: 'newdata',
        component: () => import('../views/DataView.vue'),
        meta: { permission: 'datastorage' }
    },
    {
        path: '/friends',
        name: 'friends',
        component: () => import('../views/FriendsView.vue')
    },
    // Admin Panel: one page, every section is a tab
    {
        path: '/admin',
        component: () => import('../views/AdminPanelView.vue'),
        meta: { admin: true },
        children: [
            {
                path: '',
                name: 'admin',
                // Redirected to the first allowed tab by the access guard
                meta: { adminIndex: true, title: 'Admin Panel' }
            },
            {
                path: 'users',
                name: 'adminUsers',
                component: () => import('../views/AdminUsersView.vue'),
                meta: { permission: 'admin.users.view', title: 'Users' }
            },
            {
                path: 'users/:id',
                name: 'adminUser',
                component: () => import('../views/AdminUserView.vue'),
                meta: { permission: 'admin.users.view', title: 'User' }
            },
            {
                path: 'roles',
                name: 'adminRoles',
                component: () => import('../views/AdminRolesView.vue'),
                meta: { permission: 'admin.roles', title: 'Roles' }
            },
            {
                path: 'logs',
                name: 'adminLogs',
                component: () => import('../views/AdminLogsView.vue'),
                meta: { permission: 'admin.logs', title: 'Logs' }
            }
        ]
    },
    // Old admin links
    {
        path: '/users',
        redirect: '/admin/users'
    },
    {
        path: '/logs',
        redirect: '/admin/logs'
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../views/ProfileView.vue')
    },
    {
        path: '/settings',
        name: 'settings',
        component: () => import('../views/SettingsView.vue')
    },
    {
        path: '/projects/:id',
        name: 'project',
        component: () => import('../views/ProjectView.vue')
    },
    {
        path: '/auth',
        name: 'auth',
        component: () => import('../views/AuthView.vue')
    },
    {
        path: '/documentation',
        name: 'documentation',
        component: () => import('../views/DocumentationView.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'notfound',
        component: () => import('../views/NotFoundView.vue')
    }

]

const router = createRouter({
    // history: createWebHistory(process.env.BASE_URL),
    history: createWebHashHistory(),
    routes,
    scrollBehavior () {
        document.querySelector('.app-global-wrapper').scroll({ top: 0 });
    }
})

export default router
